import React,{useEffect} from "react";
import { Helmet } from "react-helmet-async"
import { useNavigate } from "react-router-dom"
import AdminLayout from "../../components/layout/AdminLayout"


const AvaAdmin = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/ava-admin/topics');
    }, [navigate]);

    return null;
}

export default AvaAdmin;